import { render } from "./ScrollTabsBar.vue?vue&type=template&id=571de071&scoped=true"
import script from "./ScrollTabsBar.vue?vue&type=script&lang=js"
export * from "./ScrollTabsBar.vue?vue&type=script&lang=js"

import "./ScrollTabsBar.vue?vue&type=style&index=0&id=571de071&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571de071"]])

export default __exports__